import React, { useEffect, useState } from 'react';
import './Anketa.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { saveAnketa } from '../Slots/slotsApi';

function Anketa() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';
    const location = useLocation();
    const navigate = useNavigate();

    const slot = location.state?.slot;
    console.log('slot', slot)

    const [showModal, setShowModal] = useState(true);
    const [showModalAgreement, setShowModalAgreement] = useState(false);

    const slotDate = new Date(slot.datetime).toLocaleString('ru-RU', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Moscow'
    });

    const status = slot.status || 'неизвестно';

    const [previews, setPreviews] = useState([]); // локальные превью

    const [form, setForm] = useState({
        fullName: '',
        phone: '',
        country: '',
        diagnosis: '',
        intention: '',
        agreebyname: '',
        retreat: null,
        photos: [],
        age: '',
        checkAgreement1: false,
        checkAgreement2: false,
        checkAgreement3: false,
        checkAgreement4: false,
        checkAgreement5: false,
        checkAgreement6: false,
        checkAgreement7: false,
        presence: '',               // 'yes' или 'no'
        presenceAgreement: false,   // true если согласен
        presenceReason: '',         // если выбрано "нет"
    });

    const [relation, setRelation] = useState('');

    const options = ['Родитель', 'Опекун', 'Я исцеляемый(ая)'];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    // const handleFileChange = (e) => {
    //     const files = Array.from(e.target.files).slice(0, 5);
    //     setForm((prev) => ({ ...prev, photos: files }));
    // };


    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        if (files.length > 5) {
            alert('Можно загрузить не более 5 фото');
            return;
        }

        const totalSizeMB = files.reduce((sum, file) => sum + file.size, 0) / (1024 * 1024);
        if (totalSizeMB > 10) {
            alert('Общий размер файлов не должен превышать 10MB');
            return;
        }

        setForm(prev => ({ ...prev, photos: files }));

        // Генерация локальных ссылок для предпросмотра
        const localPreviews = files.map(file => URL.createObjectURL(file));
        setPreviews(localPreviews);
    };



    const handleRetreatClick = (answer) => {
        setForm((prev) => ({ ...prev, retreat: answer }));
    };

    const handleCancel = () => {
        // Здесь может быть логика отмены слота
        alert('Вы отказались от слота.');
    };

    function validateForm(form) {
        const missingFields = [];

        if (!form.fullName.trim()) missingFields.push('ФИО');
        if (!form.phone.trim()) missingFields.push('Телефон');
        if (!form.country.trim()) missingFields.push('Страна');
        if (!form.intention.trim()) missingFields.push('Намерение');
        if (form.retreat === null) missingFields.push('Информация о ретритах');
        if (!form.photos || form.photos.length === 0) missingFields.push('Фото');



        if (missingFields.length > 0) {
            return `Пожалуйста, заполните обязательные поля: ${missingFields.join(', ')}.`;
        }


        return null; // Всё ок
    }

    function validateFormAgree(form) {
        if (!form.checkAgreement1) {
            return 'Пожалуйста, подтвердите согласие с условиями (отметьте галочку).';
        }
        return null; // Всё ок
    }


    function prepareFormData(anketId, form, relation) {
        const formData = new FormData();

        formData.append('anketId', anketId);
        formData.append('fullName', form.fullName || '');
        formData.append('phone', form.phone || '');
        formData.append('country', form.country || '');
        formData.append('diagnosis', form.diagnosis || '');
        formData.append('intention', form.intention || '');
        formData.append('agreebyname', form.agreebyname || '');
        formData.append('retreat', form.retreat ? '1' : '0');
        formData.append('age', form.age || '');
        formData.append('relation', relation || '');

        formData.append('presence', form.presence || '');
        formData.append('presenceAgreement', form.presenceAgreement ? '1' : '0');
        formData.append('presenceReason', form.presenceReason || '');

        if (form.photos && form.photos.length > 0) {
            form.photos.forEach(photo => {
                formData.append('photos', photo);
            });
        }

        return formData;
    }


    const handleSave = async () => {
        const validationError = validateForm(form);
        if (validationError) {
            alert(validationError);
            return;
        }

        // try {
        //     const formData = prepareFormData(slot.anket_id, form, relation);
        //     await saveAnketa(slot.anket_id, formData);
        //     alert('Анкета сохранена успешно!');
        //     navigate('/myslots');
        // } catch (error) {
        //     console.error('Ошибка сохранения анкеты:', error);
        //     alert('Ошибка при сохранении анкеты');
        // }
        setShowModalAgreement(true)
    };

    const handleAgree = async () => {
        const validationError = validateFormAgree(form);
        if (validationError) {
            alert(validationError);
            return;
        }

        try {
            const formData = prepareFormData(slot.anket_id, form, relation);
            await saveAnketa(slot.anket_id || slot.id, formData);
            // alert('Анкета сохранена успешно!');
            navigate('/myslots');
        } catch (error) {
            console.error('Ошибка сохранения анкеты:', error);
            alert('Ошибка при сохранении анкеты');
        }

        setShowModalAgreement(false)
    };

    const handlePresenceClick = (value) => {
        setForm(prev => ({
            ...prev,
            presence: value,
            presenceAgreement: false,
            presenceReason: '',
        }));
    };

    const handleCheckboxPresenceChange = (e) => {
        const { name, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: checked,
        }));
    };

    const handleRemovePhoto = (indexToRemove) => {
        setForm(prev => ({
            ...prev,
            photos: prev.photos.filter((_, index) => index !== indexToRemove),
        }));

        setPreviews(prev => {
            // Освобождаем ссылку
            URL.revokeObjectURL(prev[indexToRemove]);
            return prev.filter((_, index) => index !== indexToRemove);
        });
    };

    useEffect(() => {
        if (!slot) return;

        setForm((prev) => ({
            ...prev,
            fullName: slot.fullName || '',
            phone: slot.phone || '',
            country: slot.country || '',
            diagnosis: slot.diagnosis || '',
            intention: slot.intention || '',
            agreebyname: slot.agreebyname || '',
            retreat: slot.retreat ?? null,
            photos: slot.photos ? slot.photos.split('|') : [],
            age: slot.age || '',
            presence: slot.presence || '',
            presenceAgreement: !!slot.presenceAgreement,
            presenceReason: slot.presenceReason || '',
        }));

        setRelation(slot.relation || '');

        if (slot.photos) {
            const fullUrls = slot.photos.split('|').map(path => `${API_BASE_URL}${path}`);
            setPreviews(fullUrls);
        }
    }, [slot]);

    if (!slot) return <div>Слот не передан</div>;

    console.log('slot', slot)



    return (
        <div className="anketa-container">
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content-anketa">
                        <p>
                            Для того, чтобы ваш сеанс состоялся, Вам необходимо заполнить Анкету до конца,
                            сохранить её и убедиться, что все необходимые поля заполнены.
                        </p>
                        <p><strong>Чтобы убедиться, что Ваша анкета заполнена до конца и отправлена нам:</strong></p>
                        <ol>
                            <li>
                                После того, как Вы заполнили анкету и нажали на кнопку <strong>СОХРАНИТЬ</strong>,
                                находящуюся в конце анкеты, Вы получите уведомление от анкеты в отдельном окне, которое сообщит, что анкета заполнена.
                            </li>
                            <li>
                                Если Вы посмотрите в разделе <strong>МОИ СЛОТЫ</strong> и найдёте там исцеление,
                                на которое Вы только что заполнили анкету – это будет означать, что анкета заполнена и мы получили её.
                            </li>
                        </ol>
                        <p><u>В противном случае наша система автоматически аннулирует Ваш сеанс в течение 3 часов с момента выбора Вами даты исцеления.</u></p>

                        <p>Получение исцеления в группе любящих и заботливых людей — это особенное событие.</p>
                        <p>Интеграция энергии, полученной во время сеанса, будет происходить в течение определенного периода времени.</p>
                        <p>
                            Мы призываем Вас взять на себя ответственность за свою жизнь и свое исцеление и не перекладывать ее на кого-либо еще,
                            включая доктора Джо Диспензу и участников группы Когерентного Исцеления.
                        </p>
                        <p>
                            Мы рекомендуем Вам выполнять практики, предложенные доктором Джо – медитировать,
                            читать книги, проходить онлайн-курсы и знакомиться с историями исцеления на YouTube.
                        </p>
                        <p>
                            Вы можете найти ресурсы на сайтах: <br />
                            <a href="https://drjoedispenza.com" target="_blank" rel="noreferrer">drjoedispenza.com</a>,{' '}
                            {/* <a href="https://drjoedispenza.ru" target="_blank" rel="noreferrer">drjoedispenza.ru</a> */}
                        </p>

                        <button className="btn_anketa" onClick={() => setShowModal(false)}>Далее</button>
                    </div>
                </div>
            )}
            {showModalAgreement && (
                <div className="modal-overlay">
                    <div className="modal-content-anketa">
                        <div>
                            <p><b>Отказ от ответственности, освобождение от претензий и согласие</b></p>

                            <p>
                                Я («Получающий исцеление»), в связи с моим участием в сеансе исцеления методом Когерентного исцеления, проводимом компанией Encephalon, Inc. («Encephalon») или от ее имени, соглашаюсь соблюдать настоящий Отказ от ответственности, освобождение от претензий и согласие («Отказ») от своего имени и от имени моих личных представителей, исполнителей завещания, наследников, членов семьи, правопреемников и цессионариев, и подтверждаю, соглашаюсь и заявляю следующее:
                            </p>

                            <p>
                                <b>1.</b> Я желаю добровольно участвовать в сеансе исцеления методом Когерентного исцеления («Участие»). Мое участие и подписание настоящего Отказа являются добровольными. Я прочитал и полностью понимаю условия настоящего Отказа и намерен быть юридически связанным его условиями. Я обладаю правоспособностью и полномочиями для подписания настоящего Отказа от своего имени, или лицо, обладающее такими полномочиями, подписало настоящий Отказ от моего имени.
                            </p>

                            <p>
                                <b>2.</b> Я заявляю, что нахожусь в достаточном физическом и психологическом состоянии для участия и не знаю о каких-либо медицинских состояниях или симптомах, которые могли бы помешать мне участвовать. Я осведомлен о том, что участие может включать в себя длительные практики молчаливой, интенсивной медитации, и я могу испытывать необычные психологические, эмоциональные и/или физические состояния ума и тела, возникающие в результате участия. Я добровольно участвую в этих мероприятиях, зная о возможности возникновения необычных событий. Я понимаю, что сеанс когерентного исцеления не заменяет традиционное медицинское лечение, и я проконсультируюсь со своим врачом или другим соответствующим медицинским работником и включу дополнительное исцеление в комплексную программу оздоровления.
                            </p>

                            <p>
                                <b>3.</b> Я согласен с тем, что Encephalon, включая его филиалы, должностных лиц, сотрудников, агентов, независимых подрядчиков, волонтеров, правопреемников и цессионариев (совместно именуемых «Представители»), не оказывает экстренную медицинскую помощь, не дает медицинских советов и не назначает использование каких-либо методов исцеления в качестве формы лечения каких-либо психических, психологических, физических или медицинских проблем, ни прямо, ни косвенно.
                            </p>

                            <p>
                                <b>4.</b> Я понимаю, что любое участие сопряжено с определенным уровнем риска, и реакцию моего организма на различные виды деятельности невозможно предсказать с полной точностью. Я понимаю риск негативной реакции организма на мое участие и принимаю на себя риск физических и/или психологических травм, заболеваний или смерти, и соглашаюсь, что мое участие всегда осуществляется на мой собственный риск. Я, от своего имени и от имени моих личных представителей, исполнителей завещаний, наследников, членов семьи, правопреемников и цессионариев, настоящим осознанно и добровольно соглашаюсь отказаться от любых претензий, освобождения от ответственности и обязуюсь не подавать в суд на Encephalon или его представителей в отношении любой ответственности, убытков, затрат, ущерба, расходов, претензий или исков любого рода за любые физические и/или психологические травмы, убытки, болезни, смерть, вред, затраты, расходы, претензии, иски или ущерб, связанные с моим участием, включая любые небрежные действия или поведение Encephalon и его представителей (совместно именуемые «Претензии»). Я также соглашаюсь возместить ущерб и оградить Encephalon и его представителей от любых претензий третьих лиц, связанных с моим участием.
                            </p>

                            <p>
                                <b>5.</b> Настоящий отказ от ответственности призван быть максимально широким и всеобъемлющим, насколько это допускается законами штата Вашингтон. Если какая-либо часть настоящего документа будет признана недействительной, остальная часть настоящего отказа от ответственности, несмотря на удаление такой недействительной части, останется в полной юридической силе.
                            </p>

                            <p>
                                <b>6.</b> В соответствии с разделом 2053.6 Кодекса деловой и профессиональной деятельности Калифорнии, вам была предоставлена следующая информация, и вы запросили дополнительную информацию или разъяснения, где это необходимо. Такая информация была предоставлена вам в письменной форме.
                            </p>

                            <p>Поэтому вы соглашаетесь и понимаете следующее:</p>

                            <ul>
                                <li>Целители, связанные с вашим сеансом когерентного исцеления, не являются лицензированными врачами.</li>
                                <li>Когерентное исцеление является альтернативой или дополнением к услугам целительных искусств, лицензированным штатом Калифорния.</li>
                                <li>Услуги, связанные с когерентным исцелением, не лицензированы штатом Калифорния.</li>
                                <li>Характер услуг, предоставляемых в ходе сеанса когерентного исцеления, был мне полностью разъяснен и раскрыт в данном заявлении об отказе от ответственности.</li>
                                <li>Теория лечения, на которой основаны услуги, предоставляемые в ходе сеанса когерентного исцеления, раскрыта в настоящем документе.</li>
                                <li>Образование, подготовка, опыт и другие квалификации каждого целителя, касающиеся услуг, предоставляемых в ходе сеанса когерентного исцеления, были мне полностью раскрыты и предоставлены.</li>
                            </ul>

                            <p>
                                Я подтверждаю, поставив галочку в поле ниже, что я прочитал и понимаю информацию, заявления, соглашения, освобождения от ответственности и отказы от прав, указанные выше, и добровольно даю свое согласие на соблюдение данного отказа от прав.
                            </p>

                            <p>
                                <b>ЕСЛИ ВЫ НЕ ЯВЛЯЕТЕСЬ ЧЕЛОВЕКОМ, КОТОРОГО ИСЦЕЛЯЮТ,</b> я заявляю и гарантирую, что являюсь родителем, законным опекуном, попечителем или должным образом уполномоченным агентом на основании действительной и имеющей юридическую силу доверенности на лицо, которого исцеляют, и что я обладаю всеми законными полномочиями для подписания данного отказа от прав и обязательства лица, которого исцеляют, в соответствии с его условиями. Я также заявляю и гарантирую, что такие полномочия действительны, актуальны и не были отозваны или ограничены.
                            </p>

                            <p>
                                Соответственно, от имени Получателя, от своего имени и от имени любых других родителей, опекунов, попечителей или агентов Получателя, я настоящим подтверждаю и соглашаюсь соблюдать условия настоящего отказа от прав, изложенные выше.
                            </p>

                            <p>
                                Я также соглашаюсь с тем, что если какое-либо заявление относительно моих полномочий является ложным, вводящим в заблуждение или неполным, я несу личную ответственность за любые возникающие претензии, убытки, ущерб, обязательства или расходы (включая разумные гонорары адвокатов), вытекающие из или связанные с таким ложным заявлением или отсутствием полномочий, и я соглашаюсь возместить ущерб и оградить от ответственности освобожденные от ответственности стороны.
                            </p>

                            <label>
                                <input
                                    type="checkbox"
                                    name="checkAgreement1"
                                    checked={form.checkAgreement1}
                                    onChange={handleCheckboxChange}
                                />
                                Я прочитал(а) и согласен(на) с вышеизложенными условиями *
                            </label>

                            <p>
                                <b>ПОЛУЧАЮЩИЙ ИСЦЕЛЕНИЕ:</b> Введите полное имя, фамилию и дату в качестве юридического подтверждения подписи и согласия с положениями настоящего отказа.<br />
                                <b>РОДИТЕЛЬ, ОПЕКУН ИЛИ УПОЛНОМОЧЕННЫЙ ПРЕДСТАВИТЕЛЬ:</b> Введите свои данные, если действуете от имени Получающего исцеление. *
                            </p>

                            <input
                                type="text"
                                name="agreebyname"
                                value={form.agreebyname}
                                onChange={handleInputChange}
                                required
                            />
                            <br /><br />
                        </div>

                        <button className="btn_anketa" onClick={handleAgree}>
                            Принять
                        </button>
                    </div>
                </div>
            )}
            <div className="slot-info">
                <p className="slot-date">Слот на {slotDate}</p>
                {/* <p className="slot-status">Статус: <span className="status-value">{status}</span></p> */}
                {/* <button className="cancel-button" onClick={handleCancel}>
                    Отказаться от слота
                </button> */}
            </div>

            <div className="anketa-instructions">
                <br></br>

                <div className="anketa-form">
                    <label className="anketa-answer">
                        <b>
                            По рекомендациям доктора Джо Диспенза требуется Ваше личное присутствие на сеансе исцеления.
                        </b>
                        <br />
                        Если Вы не сможете присутствовать лично, пожалуйста отмените сеанс (используя соответствующую кнопку в меню <i>«Мои слоты»</i>) и запишитесь на другой день и удобное для вас время.<br />
                        <br />
                        <b>Ваше присутствие на сеансе — это уже 50% успеха!</b><br />
                        <br />
                        Планируете ли вы лично присутствовать на сеансе?
                    </label>

                    <div className="retreat-buttons">
                        <button
                            type="button"
                            className={form.presence === 'yes' ? 'active' : ''}
                            onClick={() => handlePresenceClick('yes')}
                        >
                            Да
                        </button>
                        <button
                            type="button"
                            className={form.presence === 'no' ? 'active' : ''}
                            onClick={() => handlePresenceClick('no')}
                        >
                            Нет
                        </button>
                    </div>

                    {/* ЕСЛИ "ДА" — согласие с условием */}
                    {form.presence === 'yes' && (
                        <div className="anketa-confirm">
                            <label>
                                <input
                                    type="checkbox"
                                    name="presenceAgreement"
                                    checked={form.presenceAgreement}
                                    onChange={handleCheckboxPresenceChange}
                                    required
                                />
                                {' '}Я согласен, что если я не буду присутствовать, мне будет отказано в последующей записи на сеансы!
                            </label>
                        </div>
                    )}

                    {/* ЕСЛИ "НЕТ" — причина */}
                    {form.presence === 'no' && (
                        <div className="anketa-reason">
                            <label>
                                Укажите причину (например, «Я буду на работе»):
                            </label>
                            <input
                                className="anketa_input"
                                type="text"
                                name="presenceReason"
                                value={form.presenceReason}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    )}
                </div>

                <br></br>
                <div className="anketa-form">
                    <label className="anketa-answer">
                        <b>
                            Имя и фамилия исцеляемого: <span style={{ color: 'red' }}>*</span>
                        </b>
                    </label><br />

                    <input
                        className="anketa_input"
                        type="text"
                        name="fullName"
                        value={form.fullName}
                        onChange={handleInputChange}
                        required
                    /><br />


                    <small>Обязательно укажите имя и фамилию. Это необходимо для проведения исцеления</small><br></br><br></br>

                    <label className="anketa-answer">
                        <b>
                            Телефон исцеляемого: <span style={{ color: 'red' }}>*</span>
                        </b><br />
                        <input
                            className="anketa_input"
                            type="tel"
                            name="phone"
                            value={form.phone}
                            onChange={handleInputChange}
                            required
                        /><br />
                        <small>Заполняется с кодом страны и необходим для экстренной связи</small>
                    </label><br /><br />


                    <label className="anketa-answer">
                        <b>
                            В какой стране вы проживаете? <span style={{ color: 'red' }}>*</span>
                        </b><br />
                        <input
                            className="anketa_input"
                            type="text"
                            name="country"
                            value={form.country}
                            onChange={handleInputChange}
                            required
                        />
                    </label><br /><br />


                    <div>
                        <label className="anketa-answer">
                            <b>
                                Фото: <span style={{ color: 'red' }}>*</span>
                            </b><br />
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                onChange={handleFileChange}
                            /><br />
                            <small>
                                Мы показываем это фото целителям во время сеанса исцеления. Всего можно загрузить не более 5 фото.
                            </small>
                        </label><br /><br />
                    </div>

                    {/* Превью загруженных фото */}
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '30px' }}>
                        {previews.map((src, index) => (
                            <div key={index} style={{ position: 'relative', width: '15vw', height: '15vw' }}>
                                <img
                                    src={src}
                                    alt={`Фото ${index + 1}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        border: '1px solid #ccc'
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={() => handleRemovePhoto(index)}
                                    style={{
                                        position: 'absolute',
                                        top: '-8px',
                                        right: '-8px',
                                        background: 'red',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '20px',
                                        height: '20px',
                                        cursor: 'pointer',
                                        fontWeight: 'bold',
                                        lineHeight: '18px',
                                        padding: 0
                                    }}
                                    title="Удалить фото"
                                >
                                    ×
                                </button>
                            </div>

                        ))}
                    </div>


                    <div>
                        <label className="anketa-answer">
                            <b>Диагноз исцеляемого:</b><br />
                            <textarea
                                className="anketa_input txtar"
                                name="diagnosis"
                                value={form.diagnosis}
                                onChange={handleInputChange}
                                rows="4"
                            /><br />
                            <small>Заполняется по желанию, помогает нам понять степень срочности исцеления</small>
                        </label>
                    </div><br></br>

                    <div>
                        <label className="anketa-answer">
                            <b>
                                Посещали ли вы какие-либо недельные ретриты доктора Джо Диспензы?
                                <span style={{ color: 'red' }}>*</span>
                            </b><br />
                            <div className="retreat-buttons">
                                <button
                                    type="button"
                                    className={form.retreat === 'yes' ? 'active' : ''}
                                    onClick={() => handleRetreatClick('yes')}
                                >
                                    Да
                                </button>
                                <button
                                    type="button"
                                    className={form.retreat === 'no' ? 'active' : ''}
                                    onClick={() => handleRetreatClick('no')}
                                >
                                    Нет
                                </button>
                            </div>
                        </label>
                    </div><br></br>

                    <label className="anketa-answer">
                        <b>
                            Намерение: <span style={{ color: 'red' }}>*</span>
                        </b>
                    </label><br />
                    <textarea
                        className="anketa_input txtar"
                        name="intention"
                        value={form.intention}
                        onChange={handleInputChange}
                        maxLength={300}
                        rows="5"
                    />
                    <div className="char-count">Символов {form.intention.length}/300</div>


                </div>

                <p>Пожалуйста, представьте нам от 1 до 3 намерений, описывающих, как исцеляемый видит свое будущее и чего желает. По этому намерению и по вашей фотографии целители будут представлять вас в вашем будущем таким (такой), как вы опишете в намерении.</p>

                <p>Для того, чтобы правильно составить намерение - посмотрите предложенное нами видео об этом.
                    Войдя в МОИ СЛОТЫ и нажав там на кнопку АНКЕТА I, Вы попадете в свою заполненную анкету,
                    а так же увидите перед анкетой ссылки на ЗУМ, по которому пройдет сеанс и ссылки на видео для подготовки к сеансу.
                    В том числе и на видео про намерения.
                </p>
                <p>Если Вы поймете, что написали неправильное намерение в своей анкете,
                    то его можно будет исправить, заполнив строку с Вашими намерениями по-другому и сохранив изменения,
                    нажав на кнопку СОХРАНИТЬ в конце анкеты.
                </p>

                <b>Важно:</b><br></br>

                <p>Записывайте намерение в виде короткой фразы

                    Используйте настоящее или прошедшее время

                    Не используйте будущее время

                    Не используйте глаголы ХОЧУ, МОГУ.

                    Не используйте отрицания

                    Составляйте намерения от первого лица единственного числа
                </p><br></br>

                <b>ВНИМАНИЕ!</b><br></br>
                <p>В случае, если Ваше намерение составлено неправильно,
                    Ведущий Исцеления предложит Вам изменить его на правильное прямо перед сеансом Исцеления.
                </p>

                <b>Пример неправильных намерений:</b><br></br>
                У меня нет рака<br></br>
                Я избавился от всех болей<br></br>

                Я хочу иметь детей<br></br>

                Я буду здоров<br></br>

                У меня нет страхов<br></br><br></br>

                <b>Пример правильных намерений:</b><br></br>

                Я здоров<br></br>

                Мой организм находится в балансе и наполнен энергией<br></br>

                Я наполнен любовью<br></br>

                У меня крепкий иммунитет<br></br>

                Пример : «Я здоров, цел и полон сил», «Мое сердце сильное и мощное», «Я передвигаюсь легко и свободно»
            </div><br></br>
            <div>
                <p>
                    Если намерение составлено неправильно, то для того, чтобы оно вам не навредило — наши ведущие оставляют за собой право изменить его, о чем вы узнаете на Исцелении.

                    Вы лично хотели бы получить сеанс исцеления? Если нет, Вы должны быть родителем/законным опекуном или лицом, имеющим доверенность или разрешение от Исцеляемого.
                </p>
                <label className="anketa-answer">
                    <b>
                        Пожалуйста, укажите, кем именно Вы приходитесь Исцеляемому
                        <span style={{ color: 'red' }}>*</span>
                    </b><br />
                    <div className="relation-buttons">
                        {options.map((option, index) => (
                            <button
                                key={option}
                                type="button"
                                className={relation === option ? 'active' : ''}
                                onClick={() => setRelation(option)}
                            >
                                {option}
                            </button>
                        ))}
                    </div>
                </label>


                <p>
                    Если человек, которого нужно исцелить — ребенок, пожалуйста, сообщите нам, сколько ему лет.
                    Если Исцеляемый не ребёнок, то сообщать его возраст не требуется.
                </p>
                <input
                    className="anketa_input"
                    type="text"
                    name="age"
                    value={form.age}
                    onChange={handleInputChange}
                    required
                    placeholder='Количество лет'
                />
            </div>

            <div>
                <b>Процесс проведения Сеанса Исцеления</b><br></br>

                <p>Исцеление проходит по зуму в виде групповой медитации совершенно бесплатно и занимает 50-55 минут.
                    Его проводят специально подготовленные Целители, прошедшие подготовку на недельных ретритах доктора Джо Диспензы и
                    практикующие с марта 2022 года.
                </p>

                <p>Время проведения сеанса Исцеления указывается по Московскому Времени.</p>

                <p>В Исцелении принимают участие от 4 исцеляемых кроме вас, ведущий и целители из единственной официальной
                    русско говорящей группы Когерентного Исцеления по методу доктора Джо Диспенза ЕДИНОЕ СЕРДЦЕ,
                    состоящей из 102 целителей.
                </p>
                <p>Для каждого Исцеляемого проводится отдельная медитация.
                    Приходите на Исцеление за 3-5 минут до указанного времени.
                    Желательно включать камеру, чтобы у Целителей сложился с вами более глубокий контакт (по вашему желанию). В любом случае, во время сеанса ведущий проведет презентацию исцеляемых, где покажет ваше фото, назовет ваше имя и фамилию и познакомит целителей с Вашим намерением на это исцеление (информация берется нами из Анкеты Исцеляемого).
                </p>
                <p>
                    Ведущий оставляет за собой право попросить Вас изменить намерение.
                </p>
                <p>
                    ПРОСИМ взять на себя ответственность и привести себя на сеанс Исцеления. Для этого - записать в календарях и поставить себе напоминания о дате и времени сеанса.

                    Мы напомним Вам о Вашем сеансе. За день до сеанса Вы получите письмо с напоминанием, которое придет на указанный Вами электронный адрес. По телефону или в мессенджерах с Вами связываться не будут.
                </p>
                <p>
                    {/* Если Вы не пришли на Исцеление - Исцеление будет проведено в любом случае.
                    Эффект от проведенного Исцеления будет практически такой же силы, как, если бы Вы приняли участие.
                    При этом Вы не сможете пережить и прочувствовать атмосферу любви, целостности и поддержки,
                    не переживете глубоких эмоций, появляющихся от живого общения с целителями и участия в трансформирующей медитации.
                    Не сможете выразить свою глубокую благодарность и признательность. */}
                    Просьба.<br></br>
                    Запланируйте исцеление и пожалуйста прочитайте эту памятку:<br></br>
                    -Каждый человек имеет право запланировать 2 встречи с интервалом 3 недели, все другие будут отменены<br></br>
                    -Все исцеляемые должны присутствовать на сеансе исцеления<br></br>
                    -Если исцеляемый не явиться на сеанс, его исцеление будет отменено<br></br>
                    -Если Вы по какой то причине не можете присутствовать на сеансе уведомите нас за 24 часа до начала.<br></br>

                    <p>
                        Выбор всегда остается за Вами!
                    </p>

                    Во время сеанса Вам необходимо расслабиться, принять удобную позу и довериться целителям, принимая их любовь и целительную энергию.
                    Медитация проводится для целителей. Вы можете присоединиться к целителям, когда будут исцелять других исцеляемых, но во время своей части исцеления расслабьтесь, доверьтесь и принимайте.
                </p><br></br>
                <h3>Ваша ответственность</h3>
                <h3>
                    Не забывайте! Вы и только вы несете ответственность за свою жизнь. Настройтесь на свое могущество и безоговорочно поверьте в свою силу!
                </h3>
                <h4>С уважением команда Единое Сердце</h4>
                <p>Для того, чтобы отправить нам данную заполненную Анкету - нажмите на кнопку СОХРАНИТЬ.</p>

                <button className='btn_save' onClick={handleSave}>Сохранить</button>

            </div>

        </div>
    );
}

export default Anketa;
